import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { environment } from './../../../../../environments/environment';
import { SurveyService } from './../../surveys.service';
import {
  PictureChoiceUploadModel,
  SurveyCreatePDModel,
  SurveyQuestionAnswerModel,
  SurveyQuestionModel,
  SurveyTabs
} from './../../../../models/survey/survey.model';
import { Toast, ToasterService } from 'angular5-toaster/dist';
import { SidebarService } from '../../../../shared/services/sidebar.service';
import { MAX_RESPONSE_RANGE, MIN_RESPONSE_RANGE } from '../../../../shared/constants/input.constants';
import { AuthTokenService } from '../../../../shared/services/auth-token.service';
import { allowShowWordCloud } from '../../../../shared/helpers/chart-helper';

@Component({
  selector: 'app-questions-tab',
  templateUrl: './questions-tab.component.html',
  styleUrls: ['./questions-tab.component.less']
})
export class QuestionsTabComponent implements OnInit, AfterViewInit {

  private static ID = -2;

  elHeight: any;
  star = 0;
  dropdownLabel: string;
  language: string[];
  question: string[];
  info: boolean;
  addLang: boolean;
  selectedQuestion: SurveyQuestionModel;
  dateQuestion: boolean;
  fileUpload: boolean;
  groupQuestion: boolean;
  multipleChoice: boolean;
  numberQuestion: boolean;
  opinionScale: boolean;
  pictureChoice: boolean;
  ratingQuestion: boolean;
  textQuestion: boolean;
  weblinkQuestion: boolean;
  yesnoQuestion: boolean;
  dropdown: boolean;
  changeQuestion = '';
  // questionsHierarchy: any;
  childQuestions: any;
  showLoader: boolean;
  showQuestionsLoader = false;
  selectedAnswerGoToDropdown: number;
  selectedQuestionGoToDropdown = false;
  questionsForVariable: any[];
  showQuestVariPopover = false;
  questionInfoText = 'Enter @ to add a variable. Variable can be added from the second question onwards.';
  // important for binding!!!
  hasBinded: boolean;
  buttonWrapper = false;
  isDndChild: boolean;
  dropdownAnswers: boolean;
  bundles: string[] = [];
  days = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];

  months = ['Jan', 'Feb', 'Mar', 'Apr',
    'May', 'June', 'July', 'Aug',
    'Sept', 'Oct', 'Nov', 'Dec'];

  years = [];
  
  ANSWER_TYPE_CHOICE = ['SingleChoice', 'MultipleChoice']
  ANSWER_TYPE_NUMBER = ['Number'];

  MAX_RESPONSE_RANGE = MAX_RESPONSE_RANGE;
  MIN_RESPONSE_RANGE = MIN_RESPONSE_RANGE;

  @Output() surveyCreatePDModelChange = new EventEmitter<SurveyCreatePDModel>();
  isAdmin = AuthTokenService.isAdmin();
  isCustomerAdmin = AuthTokenService.isCustomerAdmin();
  showExceptionSetting = false;
  questionId: number;
  questionText: string;
  exceptionWord: string;
  isShowWordCloud = AuthTokenService.isShowWordCloud();
  constructor(private changeDetectorRef: ChangeDetectorRef,
    public surveyService: SurveyService,
    private toasterService: ToasterService,
    public sidebarService: SidebarService) {
  }

  ngOnInit() {
    for (let i = 2020; i > 1960; i--) {
      this.years.push(i);
    }
    // console.log(this.surveyCreatePDModel);
    this.sidebarService.turnOfSiderbar();
    // important for binding!!!
    this.hasBinded = false;
    this.showLoader = false;
    this.selectedAnswerGoToDropdown = -1;

    this.dropdownLabel = 'Select';
    this.language = ['english', 'serbian', 'italian', 'french', 'spanish'];
    this.question = ['short', 'long'];
    this.info = false;
    this.addLang = false;
    this.dropdown = false;
    if (this.surveyService.surveyCreatePDModel.listSurveyQuestionModel == null) {
      this.surveyService.surveyCreatePDModel.listSurveyQuestionModel = [];
    }

    if (this.surveyService.surveyCreatePDModel.listSurveyQuestionModel.length == 0) {
      this.surveyService.surveyCreatePDModel.listSurveyQuestionModel.push(new SurveyQuestionModel(QuestionsTabComponent.ID--, this.surveyService.surveyCreatePDModel.id, null));
    }

    this.prepareQuestionsHierarchyModel();
    this.checkStatusRangeResponseForListQuestion();
    // this.selectedQuestion = this.surveyService.surveyCreatePDModel.listSurveyQuestionModel[0];
    this.selectQuestion(this.surveyService.surveyCreatePDModel.listSurveyQuestionModel[0]);
    this.getHeight();
  }

  ngAfterViewInit() {
    this.getHeight();
  }

  getHeight() {
    const leftEl = document.getElementById('number-col');
    const rightEl = document.getElementById('question-col') as HTMLElement;

    setTimeout(() => {
      // if (leftEl.clientHeight > rightEl.clientHeight) {
      //   this.elHeight = rightEl.clientHeight;
      // }
      // else {
      //   this.elHeight = leftEl.clientHeight;
      // }
      if (rightEl) {
        this.elHeight = rightEl.clientHeight;
      }
    }, 100);


  }

  checkStatusRangeResponseForListQuestion() {
    this.surveyService.surveyCreatePDModel.listSurveyQuestionModel.forEach(question => {
      this.getStatusRangeResponseCB(question);
    });
  }

  //ngAfterViewChecked() {
  ngAfterContentChecked() {
    if (this.hasBinded == false) {
      // this.selectQuestion(this.selectedQuestion.id, false);
    }

    if (this.surveyService.surveyCreatePDModel.listSurveyQuestionModel.length == 0) {
      this.surveyService.surveyCreatePDModel.listSurveyQuestionModel.push(new SurveyQuestionModel(1, this.surveyService.surveyCreatePDModel.id, null));
      // this.selectedQuestion = this.surveyCreatePDModel.listSurveyQuestionModel[0];
    }

    // important for binding!!!
    this.hasBinded = true;
  }

  save(index = 0, parentIndex = null) {
    this.showQuestionsLoader = true;
    this.surveyService.sortListSurveyQuestionModel();
    this.surveyService.surveyCreatePDModel.tabId = SurveyTabs.Question;
    this.surveyService.save(this.surveyService.surveyCreatePDModel).subscribe((response) => {
      this.surveyService.surveyCreatePDModel = response;
      this.checkStatusRangeResponseForListQuestion();
      this.prepareQuestionsHierarchyModel();

      if (parentIndex != null) {
        const qId = this.surveyService.questionsHierarchy[parentIndex].childQuestions[index].id;
        this.selectQuestion(this.surveyService.surveyCreatePDModel.listSurveyQuestionModel.find(x => x.id == qId));
      } else {
        const qId = this.surveyService.questionsHierarchy[index].id;
        this.selectQuestion(this.surveyService.surveyCreatePDModel.listSurveyQuestionModel.find(x => x.id == qId));
      }
      this.showQuestionsLoader = false;
      this.surveyCreatePDModelChange.next(response);
    },
      (error) => {
        this.showQuestionsLoader = false;
      });
  }

  addQuestion(index) {
    if (this.validateSelectedQuestion() == false)
      return false;

    // this.showQuestionsLoader = true;

    // console.log(this.surveyCreatePDModel);

    // this.surveyService.save(this.surveyCreatePDModel).subscribe((response) => {
    // this.surveyCreatePDModel = response;

    // regular stuff - start
    // let newTempIndex = this.surveyCreatePDModel.listSurveyQuestionModel.length + 1;

    let newQuestion = new SurveyQuestionModel(QuestionsTabComponent.ID--, this.surveyService.surveyCreatePDModel.id, null);
    this.surveyService.surveyCreatePDModel.listSurveyQuestionModel.push(newQuestion);

    this.insertIntoQuestionsHierarchyModel(newQuestion, index);

    this.selectedQuestion = newQuestion;

    // this.selectQuestion(newQuestion);
    // regular stuff - end

    // this.showQuestionsLoader = false;
    // },
    // (error) => {
    //   // console.log(error);
    //   this.showQuestionsLoader = false;
    // });
    this.onClickSave(false);
    this.getHeight();
  }


  addSubQuestion(parentQuestion, index) {
    this.getHeight();
    if (this.validateSelectedQuestion() == false)
      return false;

    // this.showQuestionsLoader = true;

    // this.surveyService.save(this.surveyCreatePDModel).subscribe(
    //   (response) => {
    //     this.surveyCreatePDModel = response;

    // regular stuff - start
    // let newTempIndex = this.surveyCreatePDModel.listSurveyQuestionModel.length + 1;

    let newQuestionsParentId = parentQuestion.id != null ? parentQuestion.id : parentQuestion.guid;
    let newQuestion = new SurveyQuestionModel(QuestionsTabComponent.ID--, this.selectedQuestion.surveyId, newQuestionsParentId);

    this.surveyService.surveyCreatePDModel.listSurveyQuestionModel.push(newQuestion);
    this.insertIntoQuestionsHierarchyModel(newQuestion, index);
    this.selectQuestion(newQuestion);
    // regular stuff - end

    // this.showQuestionsLoader = false;
    //   },
    //   (error) => {
    //     // console.log(error);
    //     this.showQuestionsLoader = false;
    //   }
    // );
    this.onClickSave(false);

  }

  validateSelectedQuestion() {
    let valid = true;

    if (this.selectedQuestion.question == null || this.selectedQuestion.question == '')
      return false;

    if (this.selectedQuestion.answerType == null)
      return false;

    return true;
  }

  onQuestionKeyUp(e) {
    // let qIndex = this.surveyService.surveyCreatePDModel.listSurveyQuestionModel.indexOf(this.selectedQuestion);
    // if (qIndex < 1)
    //   return false;

    if (e.keyCode == 50) {
      let flatListQuestion = [];
      this.surveyService.questionsHierarchy.forEach(x => {
        if (x.answerType === 'GroupQuestions') {
          x.childQuestions.forEach(y => flatListQuestion.push(y));
        } else {
          flatListQuestion.push(x);
        }
      });

      const index = flatListQuestion.indexOf(this.selectedQuestion);
      this.questionsForVariable = flatListQuestion.slice(0, index).filter(x => x.answerType === 'SingleChoice');

      this.showQuestVariPopover = true;
    }

    if (e.target.value.indexOf('@') == -1) {
      this.showQuestVariPopover = false;
    }

  }

  onQuestionFocusOut(e) {
    if (e.target.value.indexOf('@') > -1 && this.showQuestVariPopover == false) {
      this.selectedQuestion.question = this.selectedQuestion.question.replace('@', '').trim();
    }
  }

  setVariable(e) {
    let q = this.selectedQuestion.question.replace('@', '').trim();
    this.selectedQuestion.question = this.selectedQuestion.question.replace('@', '#{' + e + ',' + q + '}');
    this.showQuestVariPopover = false;
  }


  onClickOutside(event: Object) {
    if (event && event['value'] === true) {
      this.showQuestVariPopover = false;
      if (this.selectedQuestion.question)
        if (this.selectedQuestion.question.indexOf('@') > -1)
          this.selectedQuestion.question = this.selectedQuestion.question.replace('@', '').trim();
    }
  }

  onClickOutsideQuestionType(event) {
    if (event && event['value'] === true) {
      this.dropdownAnswers = false;
    }
  }

  onClickOutsideType(event: Object) {
    if (event && event['value'] === true) {
      this.dropdown = false;
    }
  }

  onClickOutsideJump(event: Object) {
    if (event && event['value'] === true) {
      this.selectedQuestionGoToDropdown = false;
    }
  }

  onClickOutsideQuestion(event: Object, a) {
    if (this.isAdmin) {
      if (event && event['value'] === true) {
        a.dropDown = false;
      }
    }
  }

  setQuestion(q) {
    this.selectedQuestion = q;
    this.getStatusRangeResponseCB(this.selectedQuestion);
  }

  onAllowFilteringClicked(q) {
    if (this.isAdmin) {
      q.isFilter = !q.isFilter;
    }
  }

  selectQuestion(question) {
    const questionId = question.id ? question.id : question.guid;

    if (question.parentGuid != null) {
      let parentIndex = this.findIndex(this.surveyService.questionsHierarchy, 'id', question, 'parentGuid');
      parentIndex = parentIndex != null ? parentIndex : this.findIndex(this.surveyService.questionsHierarchy, 'guid', question, 'parentGuid');

      let cIndex = null;
      if (question.id != null && question.id !== undefined) {
        cIndex = this.findIndex(this.surveyService.questionsHierarchy[parentIndex].childQuestions, 'id', question, 'id');
      } else {
        cIndex = this.findIndex(this.surveyService.questionsHierarchy[parentIndex].childQuestions, 'guid', question, 'guid');
      }
      this.selectedQuestion = this.surveyService.questionsHierarchy[parentIndex].childQuestions[cIndex];
      this.getStatusRangeResponseCB(this.selectedQuestion);
    } else {
      this.selectedQuestion = this.surveyService.questionsHierarchy.find((a: SurveyQuestionModel) => a.guid === questionId || a.id === questionId);
      this.getStatusRangeResponseCB(this.selectedQuestion);
    }

    this.getHeight();
  }

  getStatusRangeResponseCB(selectedQuestion: SurveyQuestionModel) {
    if (selectedQuestion && this.isAnswerTypeNumber(selectedQuestion.answerType) && selectedQuestion.minThresholdResponse != null) {
      selectedQuestion.isInputResponseRange = true;
    } else {
      selectedQuestion.isInputResponseRange = false;
    }
  }

  isSelectedQuestion(question) {
    let id = question.id ? question.id : question.guid;
    if (id == this.selectedQuestion.id || id == this.selectedQuestion.guid) {
      return true;
    }
    return false;
  }


  deleteQuestion(id, guid) {
    let index = -1;
    if (guid != null && guid != undefined) {
      index = this.surveyService.surveyCreatePDModel.listSurveyQuestionModel.indexOf(this.surveyService.surveyCreatePDModel.listSurveyQuestionModel.find(a => a.guid == guid));
    } else {
      index = this.surveyService.surveyCreatePDModel.listSurveyQuestionModel.indexOf(this.surveyService.surveyCreatePDModel.listSurveyQuestionModel.find(a => a.id == id));
    }

    const deletedQuestion = this.surveyService.surveyCreatePDModel.listSurveyQuestionModel.splice(index, 1);

    // this.selectedQuestion = this.surveyService.surveyCreatePDModel.listSurveyQuestionModel[0];

    this.deleteFromQuestionsHierarchyModel(deletedQuestion[0]);

    this.selectedQuestion = this.surveyService.questionsHierarchy[0];
    // this.selectQuestion(this.surveyService.surveyCreatePDModel.listSurveyQuestionModel[0]);

    this.getHeight();
  }


  addAnswer() {
    this.selectedQuestion.listSurveyQuestionAnswerModel.push(new SurveyQuestionAnswerModel(this.selectedQuestion.surveyId, this.selectedQuestion.id));


    if (this.selectedQuestion.answerType == 'PictureChoice') {
      // this.updateSurveyModelSpecial();
      this.onClickSave(false);
    }
    this.getHeight();

  }

  isValidQuestions(errorOutput: any) {
    let isValid = true;
    this.surveyService.questionsHierarchy.forEach(q => {
      if (!q.question || !q.answerType) {
        isValid = false;
      }
      if (q.answerType == 'GroupQuestions') {
        q.childQuestions.forEach(cq => {
          if (!cq.answerType || !cq.question) {
            isValid = false;
          }
          if (cq.answerType == 'SingleChoice' || cq.answerType == 'Dropwdown' || cq.answerType == 'MultipleChoice' || cq.answerType == 'YesNo') {
            cq.listSurveyQuestionAnswerModel.forEach(a => {
              if (!a.answer) {
                isValid = false;
              }
            });
          }
          if (cq.answerType == 'Number' && cq.isInputResponseRange) {
            if (cq.minThresholdResponse === null
              || cq.maxThresholdResponse === null
              || cq.maxThresholdResponse < cq.minThresholdResponse
              || cq.maxThresholdResponse > MAX_RESPONSE_RANGE
              || cq.minThresholdResponse < MIN_RESPONSE_RANGE) {
              isValid = false;
            }
          }
        });
      }
      if (q.answerType == 'SingleChoice' || q.answerType == 'Dropwdown' || q.answerType == 'MultipleChoice' || q.answerType == 'YesNo') {
        q.listSurveyQuestionAnswerModel.forEach(a => {
          if (!a.answer) {
            isValid = false;
          }
        });
      }
      if (q.answerType == 'Number' && q.isInputResponseRange) {
        if (q.minThresholdResponse === null
          || q.maxThresholdResponse === null
          || q.maxThresholdResponse < q.minThresholdResponse
          || q.maxThresholdResponse > MAX_RESPONSE_RANGE
          || q.minThresholdResponse < MIN_RESPONSE_RANGE) {
          isValid = false;
          errorOutput.message = "Response range exceeds allowable limits";
        }
      }
    });
    return isValid;
  }

  onClickSave(checkPictureChoice = true) {
    const error = { message: ''};
    if (!this.isValidQuestions(error)) {
      const toast: Toast = {
        type: 'error',
        title: 'Error',
        body:  !error.message ? 'Invalid question' : error.message,
        showCloseButton: true,
        timeout: 5000
      };
      this.toasterService.pop(toast);
      return;
    }

    if (checkPictureChoice) {
      let isValid = true;
      this.surveyService.questionsHierarchy.forEach(q => {
        if (q.answerType == 'PictureChoice') {
          q.listSurveyQuestionAnswerModel.forEach(a => {
            if (!a.answer) {
              isValid = false;
            }
          });
        }
      });

      if (!isValid) {
        const toast: Toast = {
          type: 'error',
          title: 'Error',
          body: 'Some of questions is invalid!',
          showCloseButton: true,
          timeout: 5000
        };
        this.toasterService.pop(toast);
        return;
      }
    }

    if (this.selectedQuestion.parentGuid) {
      const parentIndex = this.surveyService.questionsHierarchy.findIndex(x => x.id == this.selectedQuestion.parentGuid || x.guid == this.selectedQuestion.parentGuid);
      this.surveyService.questionsHierarchy[parentIndex].childQuestions.forEach((cq, cqi) => {
        if (cq.id) {
          if (cq.id == this.selectedQuestion.id) {
            this.save(cqi, parentIndex);
            return;
          }
        } else {
          if (cq.guid == this.selectedQuestion.guid) {
            this.save(cqi, parentIndex);
            return;
          }
        }
      });
    } else {
      this.surveyService.questionsHierarchy.forEach((q, qi) => {
        if (q.id) {
          if (q.id == this.selectedQuestion.id) {
            this.save(qi);
            return;
          }
        } else {
          if (q.guid == this.selectedQuestion.guid) {
            this.save(qi);
            return;
          }
        }
      });
    }
  }


  addAnswers(a) {
    if (a.check == undefined || a.check == null)
      a.check = true;
    else
      a.check = !a.check;

  }


  setGoToQuestionId(qId, index) {
    this.selectedQuestion.listSurveyQuestionAnswerModel[index].jumpToQuestionId = qId;
    this.surveyService.surveyCreatePDModel.listSurveyQuestionModel.find(a => a.id == this.selectedQuestion.id).listSurveyQuestionAnswerModel[index].jumpToQuestionId = qId;

    this.selectedAnswerGoToDropdown = -1;
  }

  setGoToQuestionIdForQuestion(qId) {
    this.selectedQuestion.jumpToQuestionId = qId;
    this.surveyService.surveyCreatePDModel.listSurveyQuestionModel.find(a => a.id == this.selectedQuestion.id).jumpToQuestionId = qId;

    this.selectedQuestionGoToDropdown = false;
  }

  showInfo() {
    this.info = true;
  }

  toggleDropdown() {
    if (this.isAdmin) {
      this.dropdown = !this.dropdown;
    }
  }

  toggleAnswerDropdown(a) {
    if (this.isAdmin) {
      a.dropDown = !a.dropDown;
    }
  }

  toggleQuestionDropdown() {
    if (this.isAdmin) {
      this.selectedQuestionGoToDropdown = !this.selectedQuestionGoToDropdown;
    }
  }

  getQuestionTitle(jumpToQuestionId) {
    if (jumpToQuestionId == null || jumpToQuestionId == 0)
      return 'Go to...';
    else if (jumpToQuestionId == -1)
      return 'End survey';
    else {
      let questionText = '';
      if (jumpToQuestionId > 0) {
        this.surveyService.questionsHierarchy.forEach((q, qi) => {
          if (q.id === jumpToQuestionId) {
            questionText = (qi + 1) + '. ' + q.question;
            return;
          } else {
            q.childQuestions.forEach((cq, cqi) => {
              if (cq.id === jumpToQuestionId) {
                questionText = (qi + 1) + '.' + (cqi + 1) + ' ' + cq.question;
                return;
              }
            });
          }
        });
      } else {
        this.surveyService.questionsHierarchy.forEach((q, qi) => {
          if (q.guid === jumpToQuestionId) {
            questionText = (qi + 1) + '. ' + q.question;
            return;
          } else {
            q.childQuestions.forEach((cq, cqi) => {
              if (cq.guid === jumpToQuestionId) {
                questionText = (qi + 1) + '.' + (cqi + 1) + ' ' + cq.question;
                return;
              }
            });
          }
        });
      }
      return questionText;
    }
  }

  changeAnswerType(answerType) {
    this.selectedQuestion.answerType = answerType;

    // remove all answers
    if (answerType == 'YesNo' ||
      answerType == 'Text' ||
      answerType == 'PictureChoice' ||
      answerType == 'OpinionScale' ||
      answerType == 'Rating' ||
      answerType == 'Date' ||
      answerType == 'Number' ||
      answerType == 'FileUpload' ||
      answerType == 'GroupQuestions' ||
      answerType == 'MultipleChoice' ||
      answerType == 'SingleChoice' ||
      answerType == 'Statement' ||
      answerType == 'WebLink') {
      this.selectedQuestion.listSurveyQuestionAnswerModel = [];
      this.selectedQuestion.max = null;
      this.selectedQuestion.jumpToQuestionId = null;
    }


    if (answerType == 'FileUpload') {
      let ans = new SurveyQuestionAnswerModel(this.selectedQuestion.surveyId, this.selectedQuestion.id);
      ans.answer = 'FileUpload';
      this.selectedQuestion.listSurveyQuestionAnswerModel.push(ans);
    }

    // for Yes/No add predefined answers
    if (answerType == 'YesNo') {
      let answerYes = new SurveyQuestionAnswerModel(this.selectedQuestion.surveyId, this.selectedQuestion.id);
      answerYes.answer = 'Yes';
      this.selectedQuestion.listSurveyQuestionAnswerModel.push(answerYes);
      let answerNo = new SurveyQuestionAnswerModel(this.selectedQuestion.surveyId, this.selectedQuestion.id);
      answerNo.answer = 'No';
      this.selectedQuestion.listSurveyQuestionAnswerModel.push(answerNo);
    }

    if (answerType != 'Number') {
      this.selectedQuestion.minThresholdResponse = null;
      this.selectedQuestion.maxThresholdResponse = null;
    }
  }

  getAnswerTypeName(answerType) {
    if (answerType == null || answerType == 0)
      return 'Choose question type';
    else
      return this.surveyService.surveyCreatePDModel.listEnumModelAnswerType.find(a => a.value == answerType).name;
  }


  prepareQuestionsHierarchyModel() {
    let questions = this.surveyService.surveyCreatePDModel.listSurveyQuestionModel.filter(a => a.parentGuid == null);
    this.surveyService.questionsHierarchy = [];

    let i = 0;
    for (const q of questions) {
      this.surveyService.questionsHierarchy.push(q);
      this.surveyService.questionsHierarchy[i].childQuestions = this.surveyService.surveyCreatePDModel.listSurveyQuestionModel.filter(a => (a.parentGuid != null ? a.parentGuid == q.guid : false) || (q.id != null ? a.parentGuid == q.id : false));
      i++;
    }
  }

  insertIntoQuestionsHierarchyModel(question, index) {
    if (question.parentGuid != null) {
      this.surveyService.questionsHierarchy[index].childQuestions.push(question);
      this.surveyService.questionsHierarchy[index].childQuestions = this.surveyService.questionsHierarchy[index].childQuestions.slice();
    } else {
      this.surveyService.questionsHierarchy.splice(index + 1, 0, question);
      this.surveyService.questionsHierarchy = this.surveyService.questionsHierarchy.slice();
    }
  }

  findIndex(arr, key, obj, prop) {
    let index = null;
    arr.forEach((q, i) => {
      if (q[key] == obj[prop]) {
        index = i;
      }
    });
    return index;
  }

  deleteFromQuestionsHierarchyModel(question: SurveyQuestionModel) {

    // console.log(question);
    if (question.parentGuid != null) {
      let index = this.findIndex(this.surveyService.questionsHierarchy, 'id', question, 'parentGuid');
      index = index != null ? index : this.findIndex(this.surveyService.questionsHierarchy, 'guid', question, 'parentGuid');

      let cIndex = this.findIndex(this.surveyService.questionsHierarchy[index].childQuestions, 'id', question, 'id');
      let gIndex = this.findIndex(this.surveyService.questionsHierarchy[index].childQuestions, 'id', question, 'quid');
      // console.log(index, cIndex, gIndex);
      if (cIndex != null) {
        this.surveyService.questionsHierarchy[index].childQuestions.splice(cIndex, 1);
        return;
      }
      if (gIndex != null) {
        this.surveyService.questionsHierarchy[index].childQuestions.splice(gIndex, 1);
        return;
      }
      return;
    }

    if (question.id) {
      let index = this.findIndex(this.surveyService.questionsHierarchy, 'id', question, 'id');
      if (index !== null) {
        this.surveyService.questionsHierarchy.splice(index, 1);
      }
      return;
    }


    if (question.guid) {
      let index = this.findIndex(this.surveyService.questionsHierarchy, 'id', question, 'quid');
      if (index !== null) {
        this.surveyService.questionsHierarchy.splice(index, 1);
      }
      return;
    }

  }


  getSelectedClass(selQ, activeQ) {
    if (selQ.guid == null)
      return selQ.id == activeQ.id;
    else
      return selQ.guid == activeQ.guid;
  }

  ratingChange(e) {
    this.star = e;
  }


  onCbRequiredQuestionChange(e) {
    if (this.isAdmin) {
      this.selectedQuestion.isRequired = e.srcElement.checked;
    }
  }

  onCbShowDescriptionChange(e) {
    if (e.srcElement.checked)
      this.selectedQuestion.questionDescription = ' ';
    else
      this.selectedQuestion.questionDescription = null;
  }

  deleteAnswer(i) {
    this.selectedQuestion.listSurveyQuestionAnswerModel.splice(i, 1);
    this.getHeight();
  }


  selectPictureChoice(index) {
    document.getElementById('pictureChoiceFile-' + index).click();
  }

  uploadPictureChoice(e) {
    let allFiles = e.target.files;
    let fileReaded = allFiles[0];
    let reader: FileReader = new FileReader();


    if (fileReaded.type !== 'image/jpeg') {
      const toast: Toast = {
        type: 'error',
        title: 'Error',
        body: 'File ' + fileReaded.name + ' is not an image or is not a .jpg file',
        showCloseButton: true,
        timeout: 5000
      };

      this.toasterService.pop(toast);
    } else if (fileReaded.size > 1048576) {
      const toast: Toast = {
        type: 'error',
        title: 'Error',
        body: 'File ' + fileReaded.name + ' is larger then 1mb',
        showCloseButton: true,
        timeout: 5000
      };

      this.toasterService.pop(toast);
    } else {
      this.showLoader = true;
      let data = new PictureChoiceUploadModel();
      data.questionId = this.selectedQuestion.id;

      let i = parseInt(e.srcElement.id.replace('pictureChoiceFile-', '')) - 1;
      data.answerId = this.selectedQuestion.listSurveyQuestionAnswerModel[i].id;

      this.showQuestionsLoader = true;

      this.surveyService.pictureUpload(allFiles, data).subscribe(
        (response) => {

          if (this.selectedQuestion.listSurveyQuestionAnswerModel[i].answer == '' || this.selectedQuestion.listSurveyQuestionAnswerModel[i].answer == undefined)
            this.selectedQuestion.listSurveyQuestionAnswerModel[i].answer = response.filePath + '?t=' + new Date().getTime();
          else
            this.selectedQuestion.listSurveyQuestionAnswerModel[i].answer = response.filePath;

          this.showQuestionsLoader = false;
        },
        (error) => {

          this.showQuestionsLoader = false;

          const toast: Toast = {
            type: 'error',
            title: 'Error',
            body: error,
            showCloseButton: true,
            timeout: 5000
          };

          this.toasterService.pop(toast);
        }
      );

    }
  }

  getImageUrl(a) {
    return !a.answer ? '../../../../../assets/images/fileupload.jpg?' : a.answer.indexOf('http') < 0 ? environment.blobUrl + a.answer : a.answer;
  }

  isShowToggleButton(answerType: string) {
    return this.isAnswerTypeNumber(answerType) || this.isAnswerTypeChoice(answerType);
  }

  toggleContent(index: number, position: number) {
    const question = this.surveyService.questionsHierarchy[index];
    if (position !== null && position !== undefined) {
      const childQuestion = question.childQuestions[position];
      childQuestion['isToggle'] = childQuestion['isToggle'] ? false : true;
    } else {
      question.isToggle = question.isToggle ? false : true;
    }
  }

  isAnswerTypeNumber(answerType: string) {
    return this.ANSWER_TYPE_NUMBER.includes(answerType);
  }

  isAnswerTypeChoice(answerType: string) {
    return this.ANSWER_TYPE_CHOICE.includes(answerType);
  }

  getQuestionIcon(answerType: string, index: number, position: number) {
    switch (answerType) {
      case 'SingleChoice':
        this.setQuestionIcon('../../../../../assets/images/Multiple_Choice.png', index, position);
        break;
      case 'MultipleChoice':
        this.setQuestionIcon('../../../../../assets/images/Multiple_Choice.png', index, position);
        break;
      case 'Text':
        this.setQuestionIcon('../../../../../assets/images/Text_Based.png', index, position);
        break;
      case 'PictureChoice':
        this.setQuestionIcon('../../../../../assets/images/Picture.png', index, position);
        break;
      case 'YesNo':
        this.setQuestionIcon('../../../../../assets/images/Yes_No.png', index, position);
        break;
      case 'OpinionScale':
        this.setQuestionIcon('../../../../../assets/images/Opinion_Scale.png', index, position);
        break;
      case 'Rating':
        this.setQuestionIcon('../../../../../assets/images/Rating.png', index, position);
        break;
      case 'Date':
        this.setQuestionIcon('../../../../../assets/images/Date.png', index, position);
        break;
      case 'Number':
        this.setQuestionIcon('../../../../../assets/images/Number.png', index, position);
        break;
      case 'Dropwdown':
        this.setQuestionIcon('../../../../../assets/images/Dropdown.png', index, position);
        break;
      case 'GroupQuestions':
        this.setQuestionIcon('../../../../../assets/images/Question_Group.png', index, position);
        break;
      case 'FileUpload':
        this.setQuestionIcon('../../../../../assets/images/File_Upload.png', index, position);
        break;
      case 'WebLink':
        this.setQuestionIcon('../../../../../assets/images/Link.png', index, position);
        break;
      case 'Statement':
        this.setQuestionIcon('../../../../../assets/images/Text_Based.png', index, position);
        break;
      default:
        break;
    }
  }

  setQuestionIcon(iconUrl: string, index: number, position: number) {
    let iconId;
    if (position != null && position != undefined) {
      iconId = 'questionIcon' + index + position;
    } else {
      iconId = 'questionIcon' + index;
    }
    const iconElement = document.getElementById(iconId);
    iconElement.style.position = 'relative';
    iconElement.style.justifyContent = 'space-between';
    iconElement.style.padding = '10px 8px 10px 20px';
    iconElement.style.height = '8px';
    iconElement.style.background = "url('" + iconUrl + "') no-repeat";
    iconElement.style.backgroundSize = '100% 100%';
    iconElement.style.marginLeft = '5px';
    iconElement.style.marginRight = '5px';
  }

  onChangeCbResponseRange(question: any, isChildQuestion: boolean) {
    if (this.isAdminRole()) {
      if (!isChildQuestion) {
        question.isInputResponseRange = !question.isInputResponseRange;
      }
      if (question.isInputResponseRange) {
        question.minThresholdResponse = 0;
        question.maxThresholdResponse = null;
      } else {
        question.minThresholdResponse = null;
        question.maxThresholdResponse = null;
      }
    }
  }

  formatTitleQuestionType(questionType: string) {
    return questionType.replace(/([A-Z])/g, ' $1').trim()
  }

  allowShowWordCloud(type: string): boolean {
    return this.isShowWordCloud && allowShowWordCloud(type);
  }
  showExceptionWordSettings(questionId: number, questionText: string, exceptionWord: string) {
    this.questionId = questionId;
    this.questionText = questionText;
    this.exceptionWord = exceptionWord;
    this.showExceptionSetting = true;
  }
  showChange(event) {
    this.showExceptionSetting = event;
  }

  _onThemeUpdate(_event, answer){
    answer.theme = _event
  }

  isAdminRole() {
      return this.isAdmin || this.isCustomerAdmin;
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/new-survey/questions-tab/questions-tab.component.ts